"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64 = void 0;

var superstruct_1 = require("superstruct");

var assert_1 = require("./assert");
/**
 * Ensure that a provided string-based struct is valid base64.
 *
 * @param struct - The string based struct.
 * @param options - Optional options to specialize base64 validation. See {@link Base64Options} documentation.
 * @returns A superstruct validating base64.
 */


var base64 = function base64(struct) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b;

  var paddingRequired = (_a = options.paddingRequired) !== null && _a !== void 0 ? _a : false;
  var characterSet = (_b = options.characterSet) !== null && _b !== void 0 ? _b : 'base64';
  var letters;

  if (characterSet === 'base64') {
    letters = String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["[A-Za-z0-9+/]"], ["[A-Za-z0-9+\\/]"])));
  } else {
    (0, assert_1.assert)(characterSet === 'base64url');
    letters = String.raw(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["[-_A-Za-z0-9]"])));
  }

  var re;

  if (paddingRequired) {
    re = new RegExp("^(?:".concat(letters, "{4})*(?:").concat(letters, "{3}=|").concat(letters, "{2}==)?$"), 'u');
  } else {
    re = new RegExp("^(?:".concat(letters, "{4})*(?:").concat(letters, "{2,3}|").concat(letters, "{3}=|").concat(letters, "{2}==)?$"), 'u');
  }

  return (0, superstruct_1.pattern)(struct, re);
};

exports.base64 = base64;